import React from 'react';
import {useSelector} from 'react-redux';

const MobileHeaderTopLinks = () => {
    const headerLinks = useSelector((state) => state.navigation.headerLinks);

    return (
        <ul className="mobile-navigation__top-links-list">
            {headerLinks.map(headerLink => {
                return <li key={`mobile-header-link-${headerLink.link.href}`} className="mobile-navigation__top-links-list-item">
                    <a className="mobile-navigation__top-link" href={headerLink.link.href}>
                        <img className="mobile-navigation__top-link-icon" src={headerLink.icon} alt=""/>{headerLink.text}
                    </a>
                </li>
            })}
        </ul>
    );
};

export default MobileHeaderTopLinks;
